import { ThemeProvider } from "@/theme/ThemeProvider";
import QuizPage from "@/components/pages/QuizPage";

function App() {
  return (
    <ThemeProvider>
      <QuizPage />
    </ThemeProvider>
  );
}

export default App;
